export default "__VITE_ASSET__dJCaILV9__"